module.exports = __webpack_public_path__ + "static/media/qsr.46033690.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/qsr.svg
// module id = 1096
// module chunks = 36